import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PreviewImage from '../../../PreviewImage/PreviewImage'
import styles from './BackgroundSelection.module.scss'

export default function Item({ sheet, backgrounds, orderPackage }) {
  const [currentIndex, setCurrentIndex] = useState(null)
  const [, setRerender] = useState(0)

  useEffect(() => {
    if (sheet.background || sheet.backgroundId) {
      const idx = backgrounds.map((bg) => bg.id).indexOf(sheet.backgroundId.toString())
      if (idx) {
        setCurrentIndex(idx)
        return
      }
    }

    sheet.background = backgrounds[0]
    sheet.backgroundId = backgrounds[0].id
    setCurrentIndex(0)
  }, [sheet.id])

  const handleNext = (background) => {
    sheet.background = background
    sheet.backgroundId = background.id
    setCurrentIndex(0)
  }

  useEffect(() => {
    if (currentIndex === null) return
    if (currentIndex < 0) return
    if (currentIndex > backgrounds.length) return

    sheet.background = backgrounds[currentIndex]
    sheet.backgroundId = backgrounds[currentIndex].id
    orderPackage.backgroundWasResubmitted = true
    setRerender((prev) => prev + 1)
  }, [currentIndex])

  if (currentIndex === null) return null

  return (
    <div className={styles.item}>
      <span
        className={`${styles.btn} ${currentIndex === 0 ? styles.disabled : ''}`}
        onClick={() => {
          if (currentIndex === 0) return
          setCurrentIndex((prev) => prev - 1)
        }}
      >
        Prev Background
      </span>
      <div style={{ maxWidth: '300px', textAlign: 'center' }}>
        <div style={{ marginBottom: '12px', fontWeight: 'bold', fontFamily: 'sans-serif' }}>{sheet.imageType.name}</div>
        <PreviewImage isPreviewHidden={false} foregroundUrl={sheet.pose.imageUrl} backgroundUrl={backgrounds[currentIndex].imageUrl} />
      </div>
      <span
        className={`${styles.btn} ${currentIndex === backgrounds.length - 1 ? styles.disabled : ''}`}
        onClick={() => {
          if (currentIndex === backgrounds.length - 1) return
          setCurrentIndex((prev) => prev + 1)
        }}
      >
        Next Background
      </span>
    </div>
  )
}

Item.propTypes = {
  backgrounds: PropTypes.array.isRequired,
  sheet: PropTypes.object.isRequired,
}
